import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

const baseRef = 'estrutura-hierarquica';
const route = {
  arvoreHierarquica: (id_entidade_atual: string) => `${baseRef}/entidade/tree/${id_entidade_atual}`
}

@Injectable({
  providedIn: 'root'
})
export class ArvoreHierarquicaService {

  constructor(private apiService: ApiService) {

  }

  buscarArvoreHierarquica(id_entidade_atual: string) {
    return this.apiService.get<any>(route.arvoreHierarquica(id_entidade_atual));
  }
}
